module.exports = __webpack_public_path__ + "img/img-chart-03.b3a3c948.png";